import { mainSiteUrl } from '@/mocks/categories';

const benefits = [
  {
    icon: 'ri-bar-chart-line',
    title: 'Smart Organization',
    description: 'Keep all your fashion purchases neatly organized in one centralized spreadsheet. Track orders, compare items, and never lose sight of what you have bought or plan to buy.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Spending Tracking',
    description: 'Monitor your spending patterns with built-in tracking capabilities. Set budgets, analyze trends, and make informed decisions about your next purchase with confidence.',
  },
  {
    icon: 'ri-time-line',
    title: 'Time Saving',
    description: 'Automate repetitive tasks and eliminate manual tracking. With a litbuy spreadsheet, what used to take hours now takes minutes, giving you more time to enjoy your purchases.',
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-label uppercase tracking-[0.2em] text-foreground-500 mb-3">
            Why Choose
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            What Is a LitBuy Spreadsheet?
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            A litbuy spreadsheet is a powerful organizational tool designed to help fashion enthusiasts 
            and shoppers manage their purchases efficiently. From tracking orders across multiple stores 
            to comparing prices and analyzing buying patterns, it brings clarity to your shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {benefits.map((benefit, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-6 md:p-8 text-center border border-background-200/60">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 bg-accent-100 rounded-full">
                <i className={`${benefit.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-label font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            Experience it at Kaspreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}